import React, { FC } from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import injectSheet from 'react-jss'
import { Classes } from 'jss'
import { sheet } from './sheet'

interface Props {
  classes: Classes
  to: string
  label: string
  className?: string
  onClick?: (e: any, to?: string) => void
}

const HeaderNavLink: FC<Props> = ({ classes, to, label, className, onClick }) => {
  return (
    <Link to={to} className={cx(classes.link, className)} onClick={e => onClick && onClick(e, to)}>
      {label}
    </Link>
  )
}

export default injectSheet(sheet)(HeaderNavLink)
